import { render, staticRenderFns } from "./hi-values.vue?vue&type=template&id=abf5ef52&scoped=true"
import script from "./hi-values.vue?vue&type=script&lang=js"
export * from "./hi-values.vue?vue&type=script&lang=js"
import style0 from "./hi-values.vue?vue&type=style&index=0&id=abf5ef52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf5ef52",
  null
  
)

export default component.exports